import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { 
    CircleCheck,
    Clock, 
    Inbox,
    MessageCircle,
} from "lucide-react";
import MessageDashBoard from "./MessageDashBoard";

const EmployeeInboxTabs = ({ messages, selectedDepartment }) => {
    const [activeTab, setActiveTab] = useState("All");
    
    const TabLabel = ({ icon: Icon, text, count }) => (
        <div className="flex items-center justify-center gap-2">
            <Icon className="text-slate-900 w-4 h-4" />
            <span className="text-sm font-medium">
                {text} ( {count} )
            </span>
        </div>
    );

    const filteredByDept =
        selectedDepartment === "All"
            ? messages
            : messages.filter((m) => m.department === selectedDepartment);
    
    const counts = {
        All: filteredByDept.length,
        Pending: filteredByDept.filter((m) => m.priority.toLowerCase() === "pending").length,
        Responded: filteredByDept.filter((m) => m.priority.toLowerCase() === "responded").length,
        Resolved: filteredByDept.filter((m) => m.priority.toLowerCase() === "resolved").length,
    };

    const filteredMessages =
        activeTab === "All"
            ? filteredByDept
            : filteredByDept.filter(
                  (m) => m.priority.toLowerCase() === activeTab.toLowerCase()
              );

    const tabOptions = [
        { label: <TabLabel icon={Inbox} text="All" count={counts.All} />, value: "All" },
        { label: <TabLabel icon={Clock} text="Pending" count={counts.Pending}/>, value: "Pending" },
        { label: <TabLabel icon={MessageCircle} text="Responded" count={counts.Responded}/>, value: "Responded" },
        { label: <TabLabel icon={CircleCheck} text="Resolved" count={counts.Resolved}/>, value: "Resolved" },
    ];


    return (
        <div className="flex flex-col gap-2 space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
                height="h-12"
            />
            <MessageDashBoard
                messages={filteredMessages}
            />
        </div>
    );
};

export default EmployeeInboxTabs;
